if(!customElements.get('cre-price-sync')) {
  customElements.define(
    'cre-price-sync',
    class CrePriceSync extends HTMLElement {
      constructor() {
        super();

        this.sectionId = this.getAttribute('data-section-id');
        this.productVariantId = this.getAttribute('data-vid');
        this.quantityInCart = this.getAttribute('data-quantity');
        this.syncPrice = this.querySelector('.sync-price');
        this.fromMessage = this.querySelector('.from-messaging');
        this.containerUpdateDOM = this.getAttribute('data-collection') ? document.querySelector('#product-grid') : document.querySelector(`#shopify-section-${this.sectionId} .price__container`);
        this.cartUpdateUnsubscriber = undefined;
      }

      onCartUpdate(e) {
        const isProductPage = document.querySelector('main.template-product');
        if(this.productVariantId == e.productVariantId) {
          this.setAttribute('data-quantity', e?.incomingQty)
        }

        if (isProductPage) {
          this.syncPriceToProduct();
        } else {
          if(this.productVariantId == e.productVariantId) {
            this.syncPriceToProduct();
          }
        }

      }

      async syncPriceToProduct() {

        let sectionId = this.sectionId;

        let response;
        let responseStatus;
        let pageQuery = window.location.search ? `&${window.location.search.slice(1)}` : '';

        let url = window.location.pathname + `?view=full-menu-loaded&sections=main-collection-product-grid-loaded${pageQuery}`;
        if(!this.getAttribute('data-collection')) {
          url = window.location.pathname + `?${pageQuery}`;
        }

        try {

          response = await fetch(url, {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json'
            }
          })
          .then(response => {
            responseStatus = response.status;

            console.log('cdebug sync response', response)

            if(this.getAttribute('data-collection')) {
              return response.json();
            } else {
              return response.text();
            }

          });

        } catch(e) {
          console.error('cdebug error', e);
          console.log('cdebug error details', e);
        }

        console.log('cdebug response', response, responseStatus, sectionId)

        // If response is 200, then successful request
        if(responseStatus == 200) {
          if(this.getAttribute('data-collection')) {
            this.parseUpdatedSection(response?.[`main-collection-product-grid-loaded`]);
          } else {
            this.parseUpdatedSection(response);
          }
        }
      }

      parseUpdatedSection(sectionString) {
        if (!sectionString) return;

        let incomingDOM = new DOMParser()
          .parseFromString(sectionString, "text/html");

        if(this.getAttribute('data-collection')) {
          this.syncCollectionGrid(incomingDOM);
          return;
        }

        const updatedContent = incomingDOM?.querySelector(`#shopify-section-${this.sectionId} .price__container`);
        if (!updatedContent || !this.containerUpdateDOM) return;

        this.containerUpdateDOM.innerHTML = updatedContent.innerHTML;
      }

      syncCollectionGrid(incomingDOM) {
        const updatedGrid = incomingDOM?.querySelector('#product-grid');
        if (!updatedGrid || !this.containerUpdateDOM) return;

        const incomingCardsById = {};
        updatedGrid.querySelectorAll('marmeto-product-card').forEach((card) => {
          if (card.id) incomingCardsById[card.id] = card;
        });

        this.containerUpdateDOM.querySelectorAll('marmeto-product-card').forEach((existingCard) => {
          const incomingCard = incomingCardsById[existingCard.id];
          if (!incomingCard) return;
          this.syncCardElements(existingCard, incomingCard);
        });
      }

      syncCardElements(existingCard, incomingCard) {
        const incomingPriceSync = incomingCard.querySelector('cre-price-sync');
        const existingPriceSync = existingCard.querySelector('cre-price-sync');

        if (incomingPriceSync && existingPriceSync) {
          existingPriceSync.innerHTML = incomingPriceSync.innerHTML;
          ['data-quantity', 'data-percent'].forEach((attr) => {
            const value = incomingPriceSync.getAttribute(attr);
            if (value != null) existingPriceSync.setAttribute(attr, value);
          });
        }

        const incomingQtys = incomingCard.querySelector('.js-variant-cart-qtys');
        const existingQtys = existingCard.querySelector('.js-variant-cart-qtys');
        if (incomingQtys && existingQtys) {
          existingQtys.setAttribute('data-qtys', incomingQtys.getAttribute('data-qtys') || '{}');
        }

        // Form/qty visibility is owned by cre-product-form + cre-quantity-sync
        // cart listeners. Do not overwrite className here — that races the
        // ATC ↔ qty swap and can reflow the collection grid.
        const incomingQty = incomingCard.querySelector('cre-quantity-sync');
        const existingQty = existingCard.querySelector('cre-quantity-sync');

        if (incomingQty && existingQty) {
          const incomingInput = incomingQty.querySelector('input.qty-state');
          const existingInput = existingQty.querySelector('input.qty-state');
          if (incomingInput && existingInput) {
            existingInput.value = incomingInput.value;
          }
        }
      }

      connectedCallback() {
        // Declare subscriber for updates to cart
        this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
          this.onCartUpdate(event);
        });
      }

      disconnectedCallback() {
        // Declare subscriber for updates to cart
        if (this.cartUpdateUnsubscriber) {
          this.cartUpdateUnsubscriber();
        }
      }


    }
  )
}
